import React from 'react';
import { motion } from 'framer-motion';
import { lures } from '../data/copy';
export function Solution() {
  return <section className="relative w-full bg-abyss py-12 sm:py-24" aria-labelledby="solucion-title" id="senuelos" data-id="element-157" data-mp="1ejj6wb2tjjik">
      <div className="mx-auto max-w-6xl px-4 sm:px-8" data-id="element-158" data-mp="10r3a3s0ighq3">
        <p className="font-cond text-xs uppercase tracking-[0.28em] text-chartreuse sm:text-sm" data-id="element-159" data-mp="15r8vwrk3na09">
          El secreto del taller
        </p>
        <h2 id="solucion-title" className="mt-3 max-w-3xl font-display text-2xl uppercase leading-[0.95] text-bone sm:mt-4 sm:text-5xl" data-id="element-160" data-mp="qx4dt9n4bs62">
          Charly Baits se mueve solo.
          <span className="block text-chartreuse" data-id="element-161" data-mp="hwob42e78p29">Tú nomás aguanta la caña.</span>
        </h2>
        <p className="mt-4 max-w-2xl font-body text-[0.95rem] leading-relaxed text-bone/75 sm:mt-6 sm:text-lg" data-id="element-162" data-mp="mvisr10fk7ks">
          Tres años quemando moldes hasta dar con la mezcla: un polímero suave
          al tacto —blando para que el pez no lo suelte— pero con memoria
          elástica que resiste el desgarre. Aroma amasado en el interior, sal
          para la caída, y una carta de colores nacida de la turbidez y el sol
          de nuestras presas.
        </p>

        <div className="mt-8 grid gap-4 sm:mt-14 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3" data-id="element-163" data-mp="gp8nu0ggung3">
          {lures.map((lure, i) => <motion.article key={lure.name} initial={{
          opacity: 0,
          y: 28
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.55,
          delay: i * 0.1
        }} className="group border-2 border-bone/10 bg-steel transition-colors duration-300 hover:border-chartreuse/60" data-id="element-164" data-mp="btjx8mmfcgvx" data-mpi={i}>
              <div className="relative overflow-hidden" data-id="element-165" data-mp="3p8q07l3psxf1">
                <img src={lure.image} alt={`Señuelo de plástico suave Charly Baits modelo ${lure.name}`} className="h-40 w-full object-cover transition-transform duration-500 group-hover:scale-105 sm:h-56" data-id="element-166" data-mp="19dxsg9gqdawl" />
                <span className="absolute left-0 top-0 bg-chartreuse px-3 py-1.5 font-cond text-xs uppercase tracking-[0.18em] text-abyss" data-id="element-167" data-mp="1ghntyi9a0lkk">
                  {lure.tag}
                </span>
              </div>
              <div className="p-4 sm:p-6" data-id="element-168" data-mp="1qfk2d2atx2ez">
                <h3 className="font-display text-xl uppercase text-bone sm:text-2xl" data-id="element-169" data-mp="1qeiokq2fi1tk">
                  {lure.name}
                </h3>
                <p className="mt-2 font-body text-[0.9rem] leading-relaxed text-bone/70 sm:mt-3 sm:text-base" data-id="element-170" data-mp="xreisivihjgq">
                  {lure.copy}
                </p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}